import "survey-core/defaultV2.min.css";
import { Model, StylesManager } from "survey-core";
import React from "react";
import { Survey } from "survey-react-ui";
import { ProgressBar } from "./ProgressBar";
import ReactDOMServer from "react-dom/server";
StylesManager.applyTheme("defaultV2");
export const CustomSurvey = ({ surveyData }) => {
  const fsls = {
    section1: {
      a: 0,
      b: 0,
      result: "",
    },
    section2: {
      a: 0,
      b: 0,
      result: "",
    },
    section3: {
      a: 0,
      b: 0,
      result: "",
    },
    section4: {
      a: 0,
      b: 0,
      result: "",
    },
  };
  const model = new Model(surveyData);
  const setSectionValues = (section, question) => {
    if (question.name.indexOf(section) > -1) {
      if (question.value === "a") {
        fsls[section].a++;
      }
      if (question.value === "b") {
        fsls[section].b++;
      }
    }
  };

  model.onComplete.add((survey) => {
    for (const key in survey.data) {
      const question = survey.getQuestionByName(key);
      if (!!question) {
        switch (question.name.split("-")[0]) {
          case "section1":
            setSectionValues("section1", question);
            break;
          case "section2":
            setSectionValues("section2", question);
            break;
          case "section3":
            setSectionValues("section3", question);
            break;
          case "section4":
            setSectionValues("section4", question);
            break;
          default:
            break;
        }
      }
    }
    const html = ReactDOMServer.renderToStaticMarkup(
      <div className="survey-result">
        <h2>Sonuç</h2>
        <ProgressBar
          section={{
            0: { title: "Yaparak", value: fsls.section1.a },
            1: { title: "Düşünerek", value: fsls.section1.b },
          }}
          max={11}
          color={["color1", "color2"]}
        />
        <ProgressBar
          section={{
            0: { title: "Hissederek", value: fsls.section2.a },
            1: { title: "Sezgisel", value: fsls.section2.b },
          }}
          max={11}
          color={["color3", "color4"]}
        />
        <ProgressBar
          section={{
            0: { title: "Görsel", value: fsls.section3.a },
            1: { title: "İşitsel", value: fsls.section3.b },
          }}
          max={11}
          color={["color5", "color6"]}
        />
        <ProgressBar
          section={{
            0: { title: "Sıralı", value: fsls.section4.a },
            1: { title: "Bütünsel", value: fsls.section4.b },
          }}
          max={11}
          color={["color7", "color8"]}
        />
      </div>
    );
    model.completedHtml = html;
  });

  return <Survey model={model} />;
};
